import { supabase } from "@/integrations/supabase/client";
import { NpoProfile } from "@/integrations/supabase/types/opportunities";
import { 
  Profiles, 
  HostProfiles, 
  CorporateProfiles, 
  NpoProfiles 
} from "@/integrations/supabase/types/profiles";

export const getUserProfile = async (userId: string) => {
  const { data, error } = await supabase
    .from("profiles")
    .select("*")
    .eq("id", userId)
    .single();

  if (error) throw error;
  return data as Profiles["Row"];
};

export const getUserType = async () => {
  const { data, error } = await supabase.auth.getSession();

  if (error) throw error;
  return data.session?.user?.user_metadata?.user_type as string;
};

export const getHostProfile = async (hostId: string | undefined) => {
  if (!hostId) throw new Error("Host ID is required");

  const { data, error } = await supabase
    .from("host_profiles")
    .select("*")
    .eq("id", hostId)
    .single();

  if (error) throw error;
  return data as HostProfiles["Row"];
};

export const getCorporateProfile = async (corporateId: string) => {
  const { data, error } = await supabase
    .from("corporate_profiles")
    .select("*")
    .eq("id", corporateId)
    .single();

  if (error) throw error;
  return data as CorporateProfiles["Row"];
};

export const getNPOProfile = async (npoId: string) => {
  const { data, error } = await supabase
    .from("npo_profiles")
    .select("*")
    .eq("id", npoId)
    .maybeSingle();

  if (error) throw error;
  return data as unknown as NpoProfile;
};
